import classNames from "classnames";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import React, { useEffect, useState } from "react";
import { BiDollar } from "react-icons/bi";
import { FaHistory } from "react-icons/fa";
import { HiExclamationCircle } from "react-icons/hi2";
import { Api } from "../../../../services/api";
import { ConfirmDialogPague, InputNumberPague } from "../../../../styles/primeReactConfig";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { getLocal } from "../../../../utils/localStorageOps";
import { confirmFooter } from "../../../confirmFooter";
import { BaixaHistoricoDialog } from "./baixaHistorico";

export const AddPayment = ({ close, rowInfo, reload, toast }) => {
  const [partialPayment, setPartialPayment] = useState(null);
  const [partialPaymentDescription, setPartialPaymentDescription] = useState('');
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  const [showListaBaixa, setShowListaBaixa] = useState(false);
  const [categoriaBaixa, setCategoriaBaixa] = useState(null);
  const [loading, setLoading] = useState(false)
  //const usuario_id = getLocal('iduser')
  const associado_id = getLocal('associado_id')
  const categoriaBaixaOptions = [
    { label: 'Total', value: 'Baixa Total', icon: 'pi pi-plus', },
    { label: 'Parcial', value: 'Baixa Parcial', icon: 'pi pi-percentage', },
  ];
  const [cobrancaFee, setCobrancaFee] = useState('')

  useEffect(() => {
    const getData = async () => {
      //console.log("Chegou", rowInfo)
      try {
        // Faça a requisição para checar o dado necessário
        const data = await Api.get(`cobranca/consulta-fee/${rowInfo.cobranca_id}`);
        //console.log('Check data', data)
        setCobrancaFee(data.data);
        //console.log('Check fee', data.data)
      } catch (error) {
        console.error(error);
        toast('error', 'Erro ao tentar localizar Fee.');
      }
    };

    getData(); // Chama a função para buscar os dados quando o componente for montado
  }, []);

  const calculateFee = () => {
    if (categoriaBaixa === "Baixa Total") {
      //console.log("Olha o Valor: ", rowInfo.valor_corrigido)
      // Supondo que partialPaymentDescription é um número inteiro
      const inputValue = rowInfo.valor_corrigido;

      // Verificando se inputValue é um número válido
      if (!isNaN(inputValue)) {
        const feePercentage = cobrancaFee.fee_direto / 100; // Convertendo a porcentagem para decimal
        const calculatedFee = inputValue * feePercentage;

        return calculatedFee;
      }

      return 0; // Retorna 0 se o inputValue não for um número válido

    }
    else {

      // Supondo que partialPaymentDescription é um número inteiro
      const inputValue = parseInt(partialPayment, 10);

      // Verificando se inputValue é um número válido
      if (!isNaN(inputValue)) {
        const feePercentage = cobrancaFee.fee_direto / 100; // Convertendo a porcentagem para decimal
        const calculatedFee = inputValue * feePercentage;

        return calculatedFee;
      }

      return 0; // Retorna 0 se o inputValue não for um número válido
    }

  };

  const handlePayment = async () => {
    const data = {
      cobranca_id: rowInfo.cobranca_id,
      valor: partialPayment,
      tipo: 'I',
      categoria: categoriaBaixa,
      descricao: partialPaymentDescription,
      associado_id: associado_id,
    }
    setLoading(true)
    try {
      await Api.post(`/cobranca/insereBaixa`, data);
      close();
      await reload();
      toast('success', 'Pagamento adiconado com sucesso!');
    } catch (error) {
      console.error(error);
      toast('error', 'Erro ao adicionar pagamento a essa negociação.');
    } finally {
      setLoading(false)
    }
  };

  return (<div>
    <ConfirmDialog
      visible={showPaymentConfirm}
      onHide={() => setShowPaymentConfirm(false)}
      header={`Adicionar ${categoriaBaixa}`}
      message={`Deseja adicionar o pagamento de ${formatCurrency(
        partialPayment,
      )} a esta negociação?`}
      icon={<HiExclamationCircle className="text-2xl" />}
      pt={ConfirmDialogPague}
      position="center"

      acceptClassName="outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300"
      rejectClassName="outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-300"
      acceptLabel="Sim"
      rejectLabel="Não"
      accept={handlePayment}
      reject={() => setShowPaymentConfirm(false)}

      footer={confirmFooter}
    />
    {showListaBaixa && <BaixaHistoricoDialog rowInfo={rowInfo}
      close={() => setShowListaBaixa(false)} toast={toast} />
    }
    <Dialog
      header={
        <div className="flex flex-row justify-between">
          <div className="w-fit">
            <Button
              className="border-none"
              style={{padding:'10px 11px'}}
              tooltip="Histórico de Baixas"
              onClick={() => setShowListaBaixa(true)}
              icon={<FaHistory className="text-xl" />}
              iconPos="left"
            />

          </div>
          <p className="w-full">
            Adicionar Pagamento
          </p>
        </div>
      }
      visible
      pt={{
        root: 'w-screen md:w-[60vw] lg:w-[35vw] max-h-[95%] overflow-y-auto',
        headerTitle: 'font-bold text-xl w-full text-center',
      }}
      onHide={() => close()}
    >
      {rowInfo.cobranca_tipo_pagamento !== 'Em Processamento' ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            //gap: '2rem',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              width: '100%',
              paddingBottom: '1rem',
              paddingTop: '1rem',
            }}
          >
            <div style={{ textAlign: 'left' }}>
              <p style={{ marginBottom: '0.5rem' }}>
                <b>Valor
                  {rowInfo.status_negociação !== 'ativa' ?
                    " corrigido da cobrança" : " da negociação"}:</b>{' '}
                {formatCurrency(rowInfo.valor_corrigido) || 0}{' '}
              </p>
              <p>
                <b>Valor restante:</b>{' '}
                {partialPayment
                  ? formatCurrency(rowInfo.valor_corrigido - partialPayment)
                  : formatCurrency(rowInfo.valor_corrigido)}
              </p>
            </div>
            <div className="grid w-full">
              <label htmlFor="pagamento-parcial">Valor Recebido</label>
              <InputNumber
                style={{ width: '100%' }}
                id="pagamento-parcial"
                name="pagamento-parcial"
                pt={InputNumberPague}
                value={partialPayment}
                min={0}
                max={rowInfo.valor_corrigido}
                onValueChange={(e) => setPartialPayment(e.value)}
                required
                mode="currency"
                currency="BRL"
                locale="pt-BR"
              />
            </div>
            <div className="grid w-full">
              <label htmlFor="pagamento-parcial-descricao">Descrição</label>
              <InputText
                style={{ width: '100%' }}
                id="pagamento-parcial-descricao"
                name="pagamento-parcial-descricao"
                value={partialPaymentDescription}
                onChange={(e) => setPartialPaymentDescription(e.target.value)}
              />
            </div>
          </div>
          <div className="grid gap-2 justify-center w-full">
            <div className="w-auto text-center">
              <h5 className="mt-2 "><b>Tipo de Baixa</b></h5>
              <SelectButton
                value={categoriaBaixa}
                options={categoriaBaixaOptions}
                className="w-full"
                onChange={(e) => {
                  setCategoriaBaixa(e.value);
                }}
              />
            </div>
            <div className="font-bold w-full">
              <p>*A porcentagem da Pague Direto deverá ser paga posteriormente</p>
              {categoriaBaixa === "Baixa Total" &&
                <div>
                  <p className="">*A cobrança deixará de ser cobrada pela Pague Direto</p>
                  {cobrancaFee.fee_direto !== "0.00" &&
                    <p className={classNames(
                      "bg-gray-200 p-2 rounded border border-gray-300",
                      "dark:bg-gray-700 dark:border-gray-800 dark:text-white"
                    )}>Taxa da Direto  ({cobrancaFee.fee_direto}%) : {formatCurrency(calculateFee())}</p>
                  }
                </div>
              }
              {categoriaBaixa === "Baixa Parcial" &&
                <div>
                  <p className="">*A cobrança continuará a ser cobrada pela Pague Direto com um valor menor</p>
                  {(cobrancaFee.fee_direto !== "0.00" && !rowInfo.cobranca_descricao.includes("Saldo Remanescente")) &&
                    <p className={classNames(
                      "bg-gray-200 p-2 rounded-xl border border-gray-300",
                      "dark:bg-gray-700 dark:border-gray-800 dark:text-white"
                    )}>Taxa da Direto ({cobrancaFee.fee_direto}%): {formatCurrency(calculateFee())}</p>
                  }
                </div>
              }
            </div>
            <Button
              id="pagamento"
              label="Salvar"
              severity="success"
              disabled={!categoriaBaixa || !partialPayment}
              style={{ borderRadius: '0.25rem' }}
              onClick={() => {
                (rowInfo.valor_corrigido - partialPayment) >= 0 ?
                  setShowPaymentConfirm(true) : toast('warning', 'O valor recebido excede o valor da cobrança')
              }}
            />
          </div>
        </div>
      ) : (
        <div className="w-full grid justify-center">
          <p>A negociação foi realizada utilizando a plataforma digital da Direto,
            caso já tenha sido paga em meios externos à ela, a porcentagem da Pague Direto Serviços
            Financeiros deverá ser paga posteriormente
          </p>
          <div className="mt-4 w-full flex justify-center">
            <Button
              id="pagamento"
              label="Adicionar Pagamento"
              icon={<BiDollar className="text-xl" />}
              loading={loading}
              severity="success"
              style={{ borderRadius: '0.25rem', width: '50%' }}
              onClick={() => {
                setCategoriaBaixa('Baixa Total');
                setPartialPayment(rowInfo.valor_corrigido);
                setShowPaymentConfirm(true)
              }}
            />
          </div>
        </div>
      )
      }
    </Dialog>
  </div>
  )
}